export default __webpack_public_path__ + "static/media/Snd_C2.8665cc1d.mp3";